import { render, staticRenderFns } from "./OfferStatusDetail.vue?vue&type=template&id=33a18e5b"
import script from "./OfferStatusDetail.vue?vue&type=script&lang=js"
export * from "./OfferStatusDetail.vue?vue&type=script&lang=js"
import style0 from "./OfferStatusDetail.vue?vue&type=style&index=0&id=33a18e5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports